module.exports = __webpack_public_path__ + "static/img/solution-banner.361ac4f8.jpg";